import { 
  gql, 
  useQuery 
} from "@apollo/client";
import { InterestOverviewQueryQuery, QueryInterestOverviewArgs } from "../../../../../schemaTypes";

export const interestOverviewQuery = gql`
  query InterestOverviewQuery(
    $duration: String!
  ) {
    interestOverview(
      duration: $duration 
    ) {
        partnersWithInterest
        customersWithInterest
    }
  }
`;

export interface WithInterestOverview{
  loading: boolean;
  partnersWithInterest: number;
  customersWithInterest: number;
}

interface Props {
  variables: QueryInterestOverviewArgs;
  children: (data: WithInterestOverview) => React.ReactElement | null;
}

export const InterestOverviewController: React.FC<Props> = ({
  children,
  variables,
}) => {
  const { data, loading } = useQuery<
    InterestOverviewQueryQuery,
    QueryInterestOverviewArgs
  >(interestOverviewQuery, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  const partnersWithInterest = data?.interestOverview?.partnersWithInterest || 0;
  const customersWithInterest = data?.interestOverview?.customersWithInterest || 0;

  return children({
    loading,
    partnersWithInterest,
    customersWithInterest
  });
};